export const datHang = {
  sections: {
    list: { title: 'Place orders' },
    detail: { title: 'Place order details' },
  },
  lineList: {
    title: 'Order line items',
    tabOrders: 'Orders',
    tabLines: 'Line items',
    summary: 'Total {count} line items',
    noData: 'No data',
    columns: {
      maDatHang: 'Order code',
      thoiGian: 'Order time',
      trangThai: 'Status',
      chiNhanh: 'Branch',
      nguoiBan: 'Seller',
      maKhachHang: 'Customer code',
      tenKhachHang: 'Customer name',
      maHangHoa: 'Product code',
      tenHangHoa: 'Product name',
      donViTinh: 'Unit',
      soLuong: 'Quantity',
      soLuongDaXuat: 'Qty shipped',
      tongCanNang: 'Weight (kg)',
      tongTheTich: 'Volume (m³)',
      donGia: 'Unit price',
      giamGia: 'Line discount',
      giaBan: 'Sale price',
      thanhTien: 'Amount',
      giamGiaChung: 'Order discount',
      thuKhacChung: 'Other charges',
      tongCong: 'Total',
      ghiChu: 'Note',
    },
  },
  titles: { add: 'Place order' },
  columns: { code: 'Code', summary: 'Summary', status: 'Status', ngayTao: 'Created at', ngayCapNhat: 'Updated at' },
  filter: { searchPlaceholder: 'Search by order code...' },
  filters: {
    all: 'All',
    fromDate: 'From date',
    toDate: 'To date',
    dateRange: 'Date range',
    dateRangePlaceholder: 'Select date range',
    status: 'Status',
    statusSection: 'Order status',
    dateSection: 'Order time',
    salesSection: 'Sales',
    peopleSection: 'Users',
    receiver: 'Order receiver',
    deliverySection: 'Delivery',
    deliveryPartner: 'Delivery partner',
    deliveryArea: 'Delivery area',
    favoriteSection: 'Favorite',
    textDetailTitle: 'Order filters',
    khachHangPlaceholder: 'Search customer',
    locChung: 'General filter',
    maDonHang: 'By code',
    maNhanVien: 'Employee code',
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    diaChiNhanHang: 'Recipient address',
    diaChiGiaoHang: 'Shipping address',
    sortField: 'Sort by',
    sortDir: 'Order',
    sortThoiGian: 'Order time',
    sortMaDonHang: 'Order code',
    sortKhachCanTra: 'Amount due',
    sortTongTienHang: 'Merchandise total',
  },
  form: {
    code: 'Order code',
    codeAuto: 'Leave blank to auto-generate',
    customer: 'Customer',
    retailCustomer: 'Walk-in customer',
    congNoHienTai: 'Outstanding debt',
    congNoKhachNo: 'Customer owes',
    congNoNoKhach: 'We owe customer',
    channel: 'Sales channel',
    discount: 'Discount',
    discountPercent: 'Discount (%)',
    otherIncome: 'Other income',
    note: 'Note',
    lines: 'Line items',
    danhSachChiTiet: 'Detail list',
    addLine: 'Add line',
    product: 'Product',
    productName: 'Product name',
    productSearch: 'Search code / name',
    qty: 'Quantity',
    unitPrice: 'Unit price',
    lineNote: 'Line note',
    lineAmount: 'Amount',
    deliverySection: 'Delivery information',
    paymentSection: 'Payment',
    addPayment: 'Add payment line',
    removePayment: 'Remove',
    paymentAmount: 'Amount',
    tabGeneral: 'General',
    tabLines: 'Line items',
    tabDelivery: 'Delivery',
    tabPayment: 'Payment',
    discountShort: 'Discount',
    salePrice: 'Sale price',
    bangGiaDefault: 'Default price list',
    maHang: 'Item code',
  },
  fields: {
    maDatHang: 'Order code',
    maKhachHang: 'Customer code',
    nhanVienPhuTrach: 'Customer sales rep',
    soSanPham: 'Total products',
    soLuongSanPham: 'Total quantity',
    tongCanNang: 'Total weight (kg)',
    tongTheTich: 'Total volume (m³)',
    maHoaDon: 'Invoice code',
    nguoiTao: 'Order created by',
    nguoiTaoHeThong: 'System',
    tenKhachHang: 'Customer',
    khachHang: 'Customer',
    kenhBan: 'Channel',
    ngayDatHang: 'Order time',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    bangGia: 'Price list',
    trangThai: 'Status',
    chiNhanh: 'Branch',
    hinhThucGiao: 'Delivery type',
    diaChiLayHang: 'Pickup address',
    savedAddress: 'Saved delivery info',
    savedAddressPlaceholder: 'Select delivery info',
    savedAddressEmpty: 'No saved delivery info yet',
    nguoiNhan: 'Recipient',
    dienThoai: 'Recipient phone',
    diaChi: 'Delivery address',
    khuVuc: 'Province/City',
    phuongXa: 'Ward',
    soKien: 'Packages',
    trongLuong: 'Weight',
    donViTrongLuong: 'Weight unit',
    chieuDai: 'Length',
    chieuRong: 'Width',
    chieuCao: 'Height',
    donViKichThuoc: 'Dimension unit',
    dichVu: 'Delivery service',
    nguoiGiaoDoiTac: 'Deliverer / Partner',
    doiTacGiaoHang: 'Delivery partner',
    thuHoTien: 'COD',
    soTienCod: 'COD amount',
    phiTraDTGH: 'Partner fee',
    thoiGianGiaoHang: 'Delivery deadline',
    ghiChuGiaoHang: 'Delivery note',
    ghiChuChoBuuta: 'Courier note',
    tongTienHang: 'Subtotal',
    giamGia: 'Discount',
    thuKhac: 'Other income',
    khachCanTra: 'Amount due',
    ghiChu: 'Order note',
    maVanDon: 'Tracking code',
    totalAmount: 'Total amount',
    paymentMethod: 'Payment method',
    yeuThich: 'Favorite',
    actions: 'Actions',
    nguoiBan: 'Seller',
    nguoiNhanDat: 'Order taker',
    thoiGian: 'Order time',
    kichThuoc: 'Dimensions',
    thuHoTienShort: 'COD',
    khachDaTra: 'Customer paid',
    giamGiaHoaDon: 'Invoice discount',
    phiShip: 'Shipping fee',
    chiNhanhXuLy: 'Handling branch',
    chiNhanhTao: 'Created at branch',
  },
  actions: {
    copy: 'Copy',
    favorite: 'Favorite',
    changeStatus: 'Change status',
    chotThanhHoaDon: 'Finalize as invoice',
    datHang: 'Place order',
    thayDoiDatHang: 'Update order',
    taoHoaDon: 'Create invoice',
    xuatHoaDon: 'Create invoice',
    xuatHoaDonMoi: 'Export new invoice',
    ketThuc: 'Complete',
    ketThucSelected: 'Complete ({count})',
    ketThucMenu: 'Complete',
    printSelected: 'Print ({count})',
    printMenu: 'Print',
    huySelected: 'Cancel ({count})',
    huyMenu: 'Cancel',
    bulkSelected: 'Actions ({count})',
    dongY: 'Agree',
    xuLyDonHang: 'Process order',
    print: 'Print',
    exportFile: 'Export file',
    huyBo: 'Cancel',
  },
  paymentMethod: {
    TIEN_MAT: 'Cash',
    THE: 'Card',
    VI: 'Wallet',
    CHUYEN_KHOAN: 'Bank transfer',
    DIEM: 'Points',
  },
  status: {
    PHIEU_TAM: 'Draft',
    DANG_XU_LY: 'Processing',
    DANG_GIAO_HANG: 'Delivering',
    HOAN_THANH: 'Completed',
    KHONG_GIAO_DUOC: 'Undeliverable',
    DA_HUY: 'Cancelled',
  },
  messages: {
    loadError: 'Could not load orders.',
    deleteSuccess: 'Order deleted.',
    createSuccess: 'Order created.',
    updateSuccess: 'Order updated.',
    needLines: 'Please add at least one line item.',
    needKhachHang: 'Please select a customer.',
    validateThoiGianGiaoBeforeThoiGian:
      'Delivery time must not be before the order/invoice time.',
    warnStockCost: 'Stock/cost warning: {detail}',
    noData: 'No orders.',
    noLines: 'No line items.',
    listSummary: 'Total {count} orders',
    confirmDelete: 'Delete order {name}?',
    copySuccess: 'Order copied.',
    favoriteSuccess: 'Favorite updated.',
    statusSuccess: 'Order status updated.',
    confirmKetThuc: 'Complete order {name}? Status will be updated to Completed.',
    confirmKetThucSelected:
      'Complete {count} selected orders? Status will be updated to Completed. Cancelled / completed / finalized orders are skipped.',
    confirmHuy: 'Cancel order {name}? Status will be updated to Cancelled.',
    confirmHuySelected:
      'Cancel {count} selected orders? Status will be updated to Cancelled. Cancelled / completed / finalized orders are skipped.',
    huySelectedSuccess: 'Cancelled {ok}/{total} orders.',
    huySelectedPartial: 'Cancelled {ok}/{total} orders. {fail} failed or could not be cancelled.',
    huySelectedNone: 'None of the selected orders can be cancelled.',
    ketThucSelectedSuccess: 'Completed {ok}/{total} orders.',
    ketThucSelectedPartial: 'Completed {ok}/{total} orders. {fail} failed or could not be completed.',
    ketThucSelectedNone: 'None of the selected orders can be completed.',
    chotSuccess: 'Order finalized as invoice.',
    chotConfirm: 'This order will be finalized as a new HD invoice. Continue?',
    importSuccess: 'Orders imported successfully.',
    importDescription:
      'Select an Excel file using the template to import draft orders. Empty time / seller → now / current user. Sales channel defaults to Self-delivery.',
    importWillCreate: 'Will create {count} order(s) from the selected file.',
    importPreviewProgress: 'Preview {current}/{total}',
    importPreviewStopped: 'Preview stopped.',
    importPreviewDone: 'Preview finished {done}/{total} order(s).',
    importPreviewLoading: 'Preparing order {current}/{total}…',
  },
  aria: {
    columnPicker: 'Choose visible columns',
    toggleStar: 'Toggle favorite',
    selectAllPage: 'Select all rows on this page',
    selectRow: 'Select row',
  },
  detailTabs: {
    chung: 'General',
    generalInfo: 'Information',
    chiTietDonHang: 'Order details',
  },
  placeholders: {
    formTitle: 'Create / edit order',
    formBody: 'Full order forms will be added later. You can use list and detail from the API.',
    ghiChu: 'Note...',
    ghiChuGiao: 'Delivery note...',
    chonDoiTac: 'Select partner...',
  },
  xuatHoaDon: {
    sectionTitle: 'Invoices',
    tienDoTitle: 'Invoice progress',
    chiTietTungDong: 'Per-line progress',
    danhSachHoaDonCon: 'Child invoices',
    xuatHoaDonMoi: 'Create invoice',
    modalTitle: 'Create child invoice',
    modalSubtitle: 'Pick lines and quantities for the child invoice.',
    submit: 'Create invoice',
    ghiChuHoaDon: 'Child invoice note',
    ghiChuPlaceholder: 'Internal note for this batch',
    needSelect: 'Please enter a quantity for at least 1 line.',
    overQty: 'Quantity exceeds remaining of {ma} (only {conLai} left).',
    createSuccess: 'Created child invoice {ma}.',
    noLinesAvailable: 'No line can be invoiced (everything is invoiced or order is empty).',
    noLines: 'No line items.',
    chuaCoHoaDonCon: 'No child invoice has been created yet.',
    colConLai: 'Remaining',
    colXuat: 'Invoice',
    summary: 'Invoiced {daXuat}/{tong} ({conLai} left)',
    soHang: '{daHet}/{tong} lines fully invoiced',
    soHoaDonCon: '{count} child invoices',
    totalSelected: 'Selected lines',
    totalQty: 'Total qty',
  },
  pos: {
    addTab: 'Add order tab',
    history: 'History',
    tabTitle: 'Order {n}',
    tabEdit: 'Edit {code}',
    tabClone: 'Clone {code}',
    newTabDatHang: 'New place order',
    confirmCloseTitle: 'Close this tab?',
    confirmCloseBody: 'This tab has unsaved changes. Closing it will lose them.',
  },
  summary: {
    tongTienHangCount: 'Subtotal ({count})',
    tongSoLuong: 'Total quantity',
    tongTienHang: 'Subtotal',
    giamGiaPhieuDat: 'Order discount',
    tongCong: 'Total',
    hangSuaChua: 'Repair items',
  },
}
